import React from "react";
import s from "./style.module.scss";
import { PageWrapper } from "../PageWrapper";
import { ReferencesLogos } from "../ReferencesLogos";
import { useSectionsData } from "../../utils/useSectionsData.ts";

export const References = () => {
  const sections = useSectionsData();
  const scienceReferencesSection = sections.pp_v7_scientific_references_section;
  const heading = scienceReferencesSection?.tr_heading;
  const scienceReferences =
    scienceReferencesSection?.scientific_references_repeater;

  return (
    <PageWrapper backgroundColor="section_white">
      <div className={s.references}>
        <div className={s.references__title}>{heading}</div>
        <ReferencesLogos />
        <ol className={s.references__texts}>
          {scienceReferences.map(
            (text: { reference: string }, index: number) => (
              <li
                key={index}
                dangerouslySetInnerHTML={{ __html: text.reference }}
              ></li>
            )
          )}
        </ol>
      </div>
    </PageWrapper>
  );
};
